import React from "react";
import { Check, Clock, ShieldCheck, Download, Lock } from "lucide-react";
import cover from "@/assets/cover.jpeg";
import { Reveal, HotmartButton } from "./common";
import { Countdown } from "./Countdown";
import { PRICE } from "@/lib/site";

const quick = [
  "Ebook digital completo (PDF)",
  "Imprímelo las veces que quieras",
  "Acceso inmediato a tu correo",
];

export const Offer = () => {
  const savings = PRICE.normal - PRICE.offer;
  return (
    <section id="oferta" data-testid="offer-section" className="py-14 sm:py-20">
      <div className="mx-auto w-full max-w-5xl px-4 sm:px-6">
        <Reveal>
          <div className="overflow-hidden rounded-3xl border border-[hsl(var(--border))] bg-white shadow-[0_20px_50px_rgba(31,41,55,0.12)]">
            <div className="grid grid-cols-1 md:grid-cols-2">
              {/* Left: cover + list */}
              <div className="flex flex-col items-center justify-center gap-6 bg-[radial-gradient(circle_at_50%_20%,rgba(168,230,207,0.35),transparent_70%)] p-8 sm:p-10">
                <img
                  src={cover}
                  alt="Portada del ebook El Arca de Noé"
                  className="w-40 rounded-xl shadow-[0_16px_40px_rgba(31,41,55,0.2)] sm:w-48"
                  loading="lazy"
                />
                <ul className="w-full space-y-2">
                  {quick.map((q) => (
                    <li key={q} className="flex items-center gap-2 text-sm font-semibold text-[hsl(var(--brand-ink))]">
                      <Check className="h-4 w-4 text-[hsl(var(--brand-coral))]" /> {q}
                    </li>
                  ))}
                </ul>
              </div>

              {/* Right: price + cta */}
              <div className="p-8 sm:p-10">
                <span className="inline-flex items-center gap-2 rounded-full bg-[hsl(var(--brand-sun))]/50 px-3 py-1 text-xs font-extrabold uppercase tracking-wide text-[hsl(var(--brand-ink))]">
                  <Clock className="h-3.5 w-3.5" /> Oferta por tiempo limitado
                </span>
                <h2 className="mt-4 font-heading text-2xl font-extrabold text-[hsl(var(--brand-ink))] sm:text-3xl">
                  El Arca de Noé
                </h2>
                <p className="mt-1 text-sm text-muted-foreground">Coloreando las Promesas de Dios en Familia</p>

                <div className="mt-6 flex items-end gap-3">
                  <span
                    data-testid="offer-old-price"
                    className="text-xl font-bold text-muted-foreground line-through"
                  >
                    ${PRICE.normal} MXN
                  </span>
                  <span
                    data-testid="offer-new-price"
                    className="font-heading text-5xl font-extrabold leading-none text-[hsl(var(--brand-coral))]"
                  >
                    ${PRICE.offer}
                  </span>
                  <span className="pb-1 text-lg font-bold text-[hsl(var(--brand-coral))]">MXN</span>
                </div>
                <p className="mt-2 text-sm font-semibold text-[hsl(var(--brand-ink))]">
                  ¡Ahorras ${savings} MXN hoy!
                </p>

                <div className="mt-6 rounded-2xl border border-[hsl(var(--brand-coral))]/25 bg-[hsl(var(--brand-sun))]/20 p-4">
                  <p className="mb-3 flex items-center justify-center gap-1.5 text-center text-xs font-extrabold uppercase tracking-wide text-[hsl(var(--brand-ink))]">
                    <Clock className="h-3.5 w-3.5 text-[hsl(var(--brand-coral))]" />
                    El precio especial termina en:
                  </p>
                  <Countdown />
                </div>

                <div className="mt-6">
                  <HotmartButton testId="offer-primary-cta-button" variant="big" className="w-full">
                    Obtener acceso inmediato
                  </HotmartButton>
                </div>
                <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-muted-foreground">
                  <span className="inline-flex items-center gap-1.5"><Download className="h-3.5 w-3.5 text-[hsl(var(--brand-coral))]" /> Descarga inmediata</span>
                  <span className="inline-flex items-center gap-1.5"><Lock className="h-3.5 w-3.5 text-[hsl(var(--brand-coral))]" /> Compra segura</span>
                  <span className="inline-flex items-center gap-1.5"><ShieldCheck className="h-3.5 w-3.5 text-[hsl(var(--brand-coral))]" /> Garantía 7 días</span>
                </div>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
